import React from 'react';
import OwlCarousel from 'react-owl-carousel'; // Import the react-owl-carousel component
// import 'owl.carousel/dist/assets/owl.carousel.css';
// import 'owl.carousel/dist/assets/owl.theme.default.css';

const Banner = () => {
  // Dynamic data for the slides
  const slides = [
    {
      bgImage: "assets/images/banner/price1.jpg",
      shapeOne: "assets/images/shapes/slider-1-shape-1.png",
      shapeTwo: "assets/images/shapes/slider-1-shape-2.png",
      
      volunteerImages: [
        "assets/images/banner/stone.jpg",
        "assets/images/banner/pine.jpg",
        "assets/images/banner/hands-699486.jpg",
      ],
    },
     {
      bgImage: "assets/images/banner/hands-699486.jpg",
      shapeOne: "assets/images/shapes/slider-1-shape-1.png",
      shapeTwo: "assets/images/shapes/slider-1-shape-2.png",
      
      volunteerImages: [
        "assets/images/volunteer/volunteer-image-1.png",
        "assets/images/volunteer/volunteer-image-2.png",
        "assets/images/volunteer/volunteer-image-3.png",
      ],
    },
    {
      bgImage: "assets/images/banner/price2.jpg",
      shapeOne: "assets/images/shapes/slider-1-shape-1.png",
      shapeTwo: "assets/images/shapes/slider-1-shape-2.png",
      
      volunteerImages: [
        "assets/images/banner/stone.jpg",
        "assets/images/banner/pine.jpg",
        "assets/images/banner/hands-699486.jpg",
     
      ],
    },
     {
      bgImage: "assets/images/banner/price3.jpg",
      shapeOne: "assets/images/shapes/slider-1-shape-1.png",
      shapeTwo: "assets/images/shapes/slider-1-shape-2.png",
    
      volunteerImages: [
        "assets/images/banner/stone.jpg",
        "assets/images/banner/pine.jpg",
        "assets/images/banner/hands-699486.jpg",
     
      ],
    },
    {
      bgImage: "assets/images/banner/price11.jpg",
      shapeOne: "assets/images/shapes/slider-1-shape-1.png",
      shapeTwo: "assets/images/shapes/slider-1-shape-2.png",
     
      volunteerImages: [
        "assets/images/banner/stone.jpg",
        "assets/images/banner/pine.jpg",
        "assets/images/banner/hands-699486.jpg",
     
      ],
    },
    {
      bgImage: "assets/images/banner/price22.jpg",
      shapeOne: "assets/images/shapes/slider-1-shape-1.png",
      shapeTwo: "assets/images/shapes/slider-1-shape-2.png",
      
      volunteerImages: [
        "assets/images/banner/stone.jpg",
        "assets/images/banner/pine.jpg",
        "assets/images/banner/hands-699486.jpg",
     
      ],
    },
    {
      bgImage: "assets/images/banner/price33.jpg",
      shapeOne: "assets/images/shapes/slider-1-shape-1.png",
      shapeTwo: "assets/images/shapes/slider-1-shape-2.png",
      
      volunteerImages: [
        "assets/images/banner/stone.jpg",
        "assets/images/banner/pine.jpg",
        "assets/images/banner/hands-699486.jpg",
     
      ],
    },
    {
      bgImage: "assets/images/banner/price44.jpg",
      shapeOne: "assets/images/shapes/slider-1-shape-1.png",
      shapeTwo: "assets/images/shapes/slider-1-shape-2.png",
    
      volunteerImages: [
        "assets/images/banner/stone.jpg",
        "assets/images/banner/pine.jpg",
        "assets/images/banner/hands-699486.jpg",
     
      ],
    },
     ];
    // {
    //   bgImage: "assets/images/banner/tree.jpeg",
    //   shapeOne: "assets/images/shapes/slider-1-shape-1.png",
    //   shapeTwo: "assets/images/shapes/slider-1-shape-2.png",
    //   subtitle: "Give a helping hand for a child",
    //   title: ["lend a helping hand", "to who those need it"],
    //   volunteerImages: [
    //     "assets/images/volunteer/volunteer-image-1.png",
    //     "assets/images/volunteer/volunteer-image-2.png",
    //     "assets/images/volunteer/volunteer-image-3.png",
    //   ],
    // },
 

  const options = {
    loop: true,
    items: 1,
    autoplay: true,
    autoplayTimeout: 7000,
    smartSpeed: 1000,
    nav: false,
    dots: true,
    margin: 0,
  };

  return (
    <div>
      <section className="main-slider-one">
        <div className="main-slider-one__wrapper">
          <OwlCarousel className="main-slider-one__carousel cleenhearts-owl__carousel owl-carousel" {...options}>
            {slides.map((slide, index) => (
              <div key={index} className="item">
                <div className="main-slider-one__item">
                  <div
                    className="main-slider-one__bg"
                    style={{ backgroundImage: `url(${slide.bgImage})` }}
                  ></div>
                  <div
                    className="main-slider-one__shape-one"
                    style={{ backgroundImage: `url(${slide.shapeOne})` }}
                  ></div>
                  <div
                    className="main-slider-one__shape-two"
                    style={{ backgroundImage: `url(${slide.shapeTwo})` }}
                  ></div>
                 <div className="main-slider-one__content">
                 {/* Title and subtitle removed */}
                 <div className="main-slider-one__btn">
                 <a href="become-a-volunteer.html" className="cleenhearts-btn">
                 <div className="cleenhearts-btn__icon-box">
              <div className="cleenhearts-btn__icon-box__inner">
             <span className="icon-duble-arrow"></span>
           </div>
         </div>
       <span className="cleenhearts-btn__text">join with us</span>
    </a>
    <div className="volunteer-group">
      {slide.volunteerImages.map((volunteerImage, idx) => (
        <a key={idx} href="volunteer-details.html" className="volunteer-group__link">
          <img
            src={volunteerImage}
            alt={`volunteer-${idx + 1}`}
            className="volunteer-group__image"
          />
        </a>
      ))}
    </div>
  </div>
</div>

                </div>
              </div>
            ))}
          </OwlCarousel>
        </div>
      </section>
    </div>
  );
};

export default Banner;
  
